import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'AIzaSyDzeUJ-UuJ3ydtDHdTYx1vYOJnKMMwv_YU',
  authDomain: 'clone-b0cc7.firebaseapp.com',
  projectId: 'clone-b0cc7',
  storageBucket: 'clone-b0cc7.appspot.com',
  messagingSenderId: '293986779094',
  appId: '1:293986779094:web:dc557d5b7d00d7db14ae77',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
